import { ApiError } from '../../resources/ApiError';

interface UseCopyProps {
  onSuccess?: () => void;
  onError?: (error: Error | ApiError) => void;
}

export const useCopy = ({ onSuccess, onError }: UseCopyProps) => {
  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      onSuccess?.();
    } catch (error: unknown) {
      if (error instanceof Error || ApiError.isApiError(error)) {
        onError?.(error);

        return;
      }

      onError?.(new Error('알 수 없는 오류'));
    }
  };

  const copyAsync = async (promise: Promise<string>) => {
    try {
      const clipboardItem = new ClipboardItem({
        'text/plain': promise.then((text) => new Blob([text], { type: 'text/plain' })),
      });

      navigator.clipboard.write([clipboardItem]).then(onSuccess).catch(onError);
    } catch (error: unknown) {
      if (error instanceof Error || ApiError.isApiError(error)) {
        onError?.(error);

        return;
      }
    }
  };

  return { copy, copyAsync };
};
